module.exports = __webpack_public_path__ + "img/icon_dot_orange.f8336423.svg";